'use client';

import { FC, useCallback, useEffect, useState } from 'react';
import { AnimationButton, IAnimationButton } from './AnimationButton';

type AnimationAsyncButtonProps = Omit<IAnimationButton, 'onSuccessCallback'> & {
  onClickAsyncAction: () => Promise<boolean>;
  onSuccess: () => void;
};

export const AnimationAsyncButton: FC<AnimationAsyncButtonProps> = (props) => {
  const {
    onSuccess,
    onClickAsyncAction,
    ...rest
  } = props;

  const [isAnimationFinished, setFinished] = useState<boolean>(false);
  const [isActionSucceed, setSucceed] = useState<boolean>(false);

  const handleSuccess = useCallback(() => {
    setFinished(() => true);
  }, []);

  const handleClick = useCallback(async () => {
    try {
      const isSuccess = await onClickAsyncAction();

      if (isSuccess) {
        setSucceed(() => true);
      }
    } catch (error) {
      console.log(error);
    }
  }, [onClickAsyncAction]);

  useEffect(() => {
    if (isAnimationFinished && isActionSucceed) {
      onSuccess();
    }
  }, [isActionSucceed, isAnimationFinished, onSuccess]);

  return (
    <AnimationButton
      {...rest}
      onSuccessCallback={handleSuccess}
      onClickCallback={handleClick}
    />
  );
};
